import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import { MdVisibility, MdArrowForward, MdVisibilityOff } from "react-icons/md"
import { IntlProvider, FormattedNumber } from "react-intl"

import ProfissionalAPI from "../../servicos/ProfissionalAPI"
import { ContextoGeral } from "../../contextos/ContextoGeral"
import AppAPI from "../../servicos/AppAPI"
import { relatorioMenuDisponivel } from "../../utils/relatorioModulo"
import { lerSaldoOculto, salvarSaldoOculto } from "../../utils/preferenciaSaldoOculto"
import { chamarWhatsComMsg } from "./../uteis/telefone"
import styles from "./BtnSaldo.module.css"

export default function BtnSaldo() {
	const navigate = useNavigate()

	const [showArrow, setShowArrow] = useState(false)
	const { dados } = useContext(ContextoGeral)
	const [saldo, setSaldo] = useState(0)
	const [plific, setPlific] = useState([])
	const [statusSaldo, setStatusSaldo] = useState('loading')
	const [oculto, setOculto] = useState(() => lerSaldoOculto(dados?.idProf))

	useEffect(() => {
		setOculto(lerSaldoOculto(dados?.idProf))
	}, [dados?.idProf])

	useEffect(() => {
		let cancelado = false

		async function buscarSaldo() {
			if (!dados?.dominio || !dados?.idProf || !dados?.token) {
				return
			}
			try {
				const jsonConfig = await AppAPI.buscarConfigRelatorio(dados)
				if (!cancelado && jsonConfig.resultado && jsonConfig.dados.campos) {
					const menuVisivel = relatorioMenuDisponivel(jsonConfig)
					setShowArrow(menuVisivel && jsonConfig.dados.campos.acertos.exibicao)
				}

				const retornoSaldo = await ProfissionalAPI.buscarSaldo(dados)
				if (cancelado) return

				if (retornoSaldo.resultado) {
					const dadosSaldo = retornoSaldo.dados || {}
					if (dadosSaldo.exibicaoMenu === false) {
						setSaldo(0)
						setStatusSaldo("hidden")
						return
					}
					setSaldo(Number(dadosSaldo.saldoTotal ?? dadosSaldo.saldo ?? dadosSaldo.saldoDiario ?? 0))
					setPlific(dadosSaldo.plific)
					setStatusSaldo("visible")
				} else {
					setSaldo(0)
					setStatusSaldo('hidden')
				}
			} catch {
				if (!cancelado) {
					setSaldo(0)
					setStatusSaldo('hidden')
				}
			}
		}

		buscarSaldo()
		return () => { cancelado = true }
	}, [dados?.dominio, dados?.idProf, dados?.token])

	if (statusSaldo === 'hidden') {
		return null
	}

	if (statusSaldo === 'loading') {
		return (
			<div
				className={`${styles.area} ${styles.placeholder}`}
				aria-busy="true"
				aria-label="Carregando saldo"
			>
				<div className={styles.placeholderLabel} />
				<div className={styles.placeholderIcon} />
				<div className={styles.placeholderValor} />
			</div>
		)
	}

	function alternarOlho() {
		const proximo = !oculto
		setOculto(proximo)
		salvarSaldoOculto(dados?.idProf, proximo)
	}

	return (
		<div className={`text-center font-normal ${styles.area}`}>
			Saldo
			<div className="flex justify-center items-center gap-2">
				{oculto
					? <MdVisibilityOff size={25} onClick={alternarOlho} />
					: <MdVisibility size={25} onClick={alternarOlho} />
				}
			</div>
			<div className="flex justify-center gap-3 p-2 font-thin">
				<div className="w-50 rounded">
					{oculto ? (
						"R$ ••••"
					) : (
						<IntlProvider locale="pt-BR">
							<FormattedNumber value={saldo} style="currency" currency="BRL" />
						</IntlProvider>
					)}
				</div>
				{showArrow && <div className="absolute right-11">
					<MdArrowForward size={25} onClick={() => navigate("/app/relatorios", { state: { tab: "C" } })} />
				</div>}
			</div>
			<BtnPlific plific={plific} />
		</div>
	)
}

function BtnPlific({ plific }) {
	const { dados } = useContext(ContextoGeral)

	return <div className="mb-4 small mx-2">
		{plific?.mostrarBotao == 'S' ?
			<button className="w-100" onClick={() => { chamarWhatsComMsg(plific.whatsApp, plific.mensagem, dados.idProf, dados.nome) }}>
				{plific?.nomeBotao ? plific?.nomeBotao : 'Pedir adiantamento'}
			</button>
			: ''}
	</div>
}
